import * as React from "react";
import * as ReactRedux from "react-redux";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import * as _ from "lodash";
import { PortraitView } from "../../components/ui/PortraitView/PortraitView";
import { IStoreState } from "../../_reducers";
import { iActionType, Translation, graphData } from "../../models/models";
import Navigation from "../../components/ui/Navigation/Navigation";
import { Router } from "react-router";
import { Footer } from "../../components/ui/Footer/Footer";
import { IS_MOBILE, IS_EMBED } from "../../config";
import { SCREEN_WIDTH } from "../../constants";
import { BarList } from "../../components/ui/BarList/BarList";
import { BarItem } from "../../components/ui/BarList/BarItem";
import { ACTIONS } from "./../../controllers/App/actions";
import { DotPagination } from "../../components/ui/DotPagination/DotPagination";
import { LineGraph } from "../../components/ui/LineGraph/LineGraph";
import TreeGraph from "../../components/ui/TreeGraph/TreeGraph";

export interface MainPageProps extends ReactRedux.DispatchProp<any> {
  className?: string;
  locale: Translation;
  navData: any;
  data: any;
  match: any;
  selectedGraph: any;
  selectedFilter: any;
  selectedSecondFilter: any;
  onSetGraph: (e) => any;
  onSelectedFilter: (e) => any;
  onSelectedSecondFilter: (e) => any;
}

const INIT_STATE: MainPageState = {
  currentPage: 0
};

export interface MainPageState {
  currentPage?: number;
}

export class MainPage extends React.Component<MainPageProps, MainPageState> {
  constructor(props: MainPageProps) {
    super(props);
    this.state = INIT_STATE;
    this.setGraphData(props);
  }

  componentWillReceiveProps(props: MainPageProps) {
    if (
      ((this.props.data || []) as any[]).length !==
      ((props.data || []) as any[]).length
    ) {
      this.setGraphData(props);
    }
  }

  private setGraphData = (props: MainPageProps): void => {
    if (!props.data || props.data.length === 0) {
      return;
    }

    let currentTab = props.match.params.tab || "";
    let currentSub = props.match.params.sub || "";
    let currentCat = props.match.params.cat || "";

    if (
      !currentTab ||
      !currentSub ||
      !props.data[`${currentTab}-${currentSub}`]
    ) {
      return;
    }

    const graphData = currentCat
      ? props.data[`${currentTab}-${currentSub}-${currentCat}`]
      : props.data[`${currentTab}-${currentSub}`];
    props.onSetGraph(graphData);

    if (!!graphData && graphData.firstKey && graphData.firstKey.length > 0) {
      this.setState(
        {
          currentPage: 0
        },
        () => {
          this.props.onSelectedFilter(graphData.firstKey[0]);

          if (graphData.firstKey.length > 1) {
            this.props.onSelectedSecondFilter(graphData.firstKey[1]);
          }
        }
      );
    }
  };

  handleSetFilter = e => {
    const newVal = e.target.value;
    this.setState(
      {
        currentPage: 0
      },
      () => {
        this.props.onSelectedFilter(newVal);
      }
    );
  };

  handleSetSecondaryFilter = e => {
    const newVal = e.target.value;
    this.setState(
      {
        currentPage: 0
      },
      () => {
        this.props.onSelectedSecondFilter(newVal);
      }
    );
  };

  getFilteredPageData = (): any[] => {
    if (!this.props.selectedGraph || !this.props.selectedGraph.data) {
      return [];
    }

    return this.props.selectedGraph.data.filter(
      graph =>
        !this.props.selectedFilter ||
        this.props.selectedFilter === graph.key ||
        this.props.selectedFilter === "all-tech-giants"
    );
  };

  getCurrentPageData = (): any[] => {
    const filteredData = this.getFilteredPageData();

    const MAX_DATA_PER_PAGE = !IS_MOBILE ? 6 : filteredData.length;

    const startPage = this.state.currentPage * MAX_DATA_PER_PAGE;
    return _.range(
      startPage,
      Math.min(startPage + MAX_DATA_PER_PAGE, filteredData.length)
    ).map(idx => {
      if (idx < filteredData.length) {
        return filteredData[idx];
      }
      return null;
    });
  };

  onPaginatorSelect = (idx: number): void => {
    this.setState({
      currentPage: idx
    });
  };

  goBackButtonClicked = (ev: React.MouseEvent<HTMLElement>): void => {
    ev.stopPropagation();
    ev.preventDefault();

    const currentTab = this.props.match.params.tab;
    const dataSet = this.props.data[`${currentTab}-categories`];

    this.props.onSetGraph(dataSet);
    this.props.onSelectedFilter("all-tech-giants");

    window.location.href =
      window.location.href.split("#")[0] +
      (IS_EMBED ? "#/embed/" : "#") +
      currentTab +
      "/categories";
  };

  render() {
    let { props, state } = this;
    let cls = this.props.className || "";

    let currentTab = this.props.match.params.tab;
    let currentUrl = this.props.match.url;
    let currentSub = this.props.match.params.sub;
    let currentCat = this.props.match.params.cat;

    const getHighestElement = values =>
      values.reduce(
        (prev, current) => (prev.value > current.value ? prev : current)
      );

    const calculateBarWidth = (value, maxValue) => {
      return (value / maxValue) * 100;
    };

    let maxValue;
    if (this.props.selectedGraph.data) {
      maxValue = getHighestElement(props.selectedGraph.data).value;
    }

    return (
      <div className={"main-page " + cls}>
        {SCREEN_WIDTH.IS_SMALL() && IS_MOBILE ? (
          <PortraitView locale={this.props.locale} />
        ) : (
          <div
            style={{
              paddingBottom: "50px"
            }}
          >
            <Navigation
              navData={this.props.navData}
              currentTab={currentTab}
              currentUrl={currentUrl}
              currentSub={currentSub}
              match={this.props.match}
            />

            <div className="main-page__copy">
              {this.props.selectedGraph.copy}
            </div>

            <div
              className={
                currentSub === "categories" || currentSub === "ceos"
                  ? "filter-container middle-filter"
                  : "filter-container"
              }
            >
              {currentSub === "ceos" && (
                <div className="main-page__select-text">
                  {this.props.locale.selectText}
                </div>
              )}
              {currentSub === "categories" &&
                !IS_MOBILE && (
                  <div className="main-page__select-text">
                    {currentCat ? (
                      <span onClick={this.goBackButtonClicked}>GO BACK</span>
                    ) : (
                      this.props.locale.selectText
                    )}
                  </div>
                )}

              {this.props.selectedGraph.filters && (
                <div className="select-filter-container">
                  <select
                    className={
                      currentSub === "versus"
                        ? "selection-button first-versus-version"
                        : currentCat
                          ? "selection-button cat-version"
                          : "selection-button"
                    }
                    onChange={this.handleSetFilter}
                    value={this.props.selectedFilter}
                  >
                    {this.props.selectedGraph.filters
                      .filter(
                        filter => filter.key !== this.props.selectedSecondFilter
                      )
                      .map(filter => (
                        <option key={filter.key} value={filter.key}>
                          {filter.label}
                        </option>
                      ))}
                  </select>
                  <div
                    className={
                      currentCat ? "select-icon cat-version" : "select-icon"
                    }
                  >
                    <i className="icon-patent-icon-down" />
                  </div>
                </div>
              )}
              {currentSub === "versus" && (
                <div className="vs-label">
                  <p>VS</p>
                </div>
              )}
              {!!this.props.selectedGraph.requiresSecondaryFilters && (
                <div className="select-filter-container">
                  <select
                    className={
                      currentSub === "versus"
                        ? "secondary-selection-button versus-version"
                        : "secondary-selection-button"
                    }
                    onChange={this.handleSetSecondaryFilter}
                    value={this.props.selectedSecondFilter}
                  >
                    {this.props.selectedGraph.filters
                      .filter(
                        filter => filter.key !== this.props.selectedFilter
                      )
                      .map(filter => (
                        <option key={filter.key} value={filter.key}>
                          {filter.label}
                        </option>
                      ))}
                  </select>
                  <div className="secondary-select-icon">
                    <i className="icon-patent-icon-down" />
                  </div>
                </div>
              )}
            </div>

            <div className="main-page__graphs">
              {this.props.match.params.sub === "overall" && (
                <BarList className="no-filtering">
                  {this.props.selectedGraph.data &&
                    props.selectedGraph.data.map((graph, i) => {
                      return (
                        <BarItem
                          key={i}
                          keyIndex={i}
                          label={graph.label}
                          value={graph.value}
                          width={calculateBarWidth(graph.value, maxValue)}
                          selectedTab={currentTab}
                          selectedData={this.props.selectedGraph}
                        />
                      );
                    })}
                </BarList>
              )}

              {this.props.match.params.sub === "ceos" && <>
                <BarList>
                  {this.props.selectedGraph.data &&
                    this.getCurrentPageData().map((graph, i) => {
                      return (
                        <BarItem
                          key={i}
                          keyIndex={i}
                          label={graph.label}
                          value={graph.value}
                          person={graph.ceo}
                          year={graph.year}
                          className="biggerBar"
                          width={calculateBarWidth(graph.value, maxValue)}
                          selectedTab={currentTab}
                          selectedData={this.props.selectedGraph}
                          selectedCeoFilter={
                            this.props.selectedFilter !== "all-tech-giants" &&
                            "ceo-filter"
                          }
                        />
                      );
                    })}
                </BarList>
                {!IS_MOBILE && (
                  <DotPagination
                    pagesCount={Math.ceil(
                      this.getFilteredPageData().length / 6
                    )}
                    currentIndex={this.state.currentPage}
                    onPageSelect={this.onPaginatorSelect}
                  />
                )}
              </>}

              {this.props.match.params.sub === "over-time" && [
                <LineGraph
                  data={this.props.selectedGraph.data}
                  currentFilter={this.props.selectedFilter}
                  currentTab={currentTab}
                />
              ]}

              {this.props.match.params.sub === "versus" && [
                <LineGraph
                  data={this.props.selectedGraph.data}
                  currentFilter={this.props.selectedFilter}
                  currentSecondFilter={this.props.selectedSecondFilter}
                  currentTab={currentTab}
                />
              ]}

              {this.props.match.params.sub === "categories" ? (
                this.props.match.params.cat ? (
                  <BarList>
                    {this.props.selectedGraph.data &&
                      this.getCurrentPageData().map((graph, i) => {
                        return (
                          <BarItem
                            key={i}
                            keyIndex={i}
                            label={graph.label}
                            value={graph.value}
                            width={calculateBarWidth(graph.value, maxValue)}
                            selectedTab={currentTab}
                            selectedData={this.props.selectedGraph}
                          />
                        );
                      })}
                  </BarList>
                ) : (
                  <TreeGraph
                    graphObj={this.props.selectedGraph}
                    currentFilter={this.props.selectedFilter}
                    currentSub={currentSub}
                    currentTab={currentTab}
                    navData={this.props.navData}
                  />
                )
              ) : null}
            </div>
            <div className="main-page__campaign-logo">
              <a href="#/">
                <img
                  alt="The UK Domain - Helping businesses achieve more online"
                  src="img/campaign-logo.png"
                />
              </a>
            </div>

            <Footer
              locale={this.props.locale}
              version={SCREEN_WIDTH.IS_SMALL() && !IS_MOBILE && "custom-footer"}
              colorFooter={currentTab === "unicorns" ? "yellow" : ""}
            />
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (
  state: IStoreState,
  ownProps
): Partial<MainPageProps> => {
  return {
    locale: state.app.locale,
    navData: state.app.navData,
    data: state.app.data,
    selectedGraph: state.app.selectedGraph,
    selectedFilter: state.app.selectedFilter,
    selectedSecondFilter: state.app.selectedSecondFilter
  };
};

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      onSetGraph: ACTIONS.SET_GRAPH,
      onSelectedFilter: ACTIONS.SET_FILTER,
      onSelectedSecondFilter: ACTIONS.SET_SECOND_FILTER
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainPage);
